const openVideo = e => {
  const wrapper = document.querySelector(`[data-video=${e.currentTarget.getAttribute('id')}]`);
  const video = wrapper.querySelector('.product-video');
  wrapper.classList.remove('hidden');
  document.querySelector('body').classList.add('open-cart-drawer');
  video.play();
}

const closeVideo = e => {
  const wrapper = document.querySelector(`[data-video=${e.currentTarget.dataset.videoClose}]`);
  const video = wrapper.querySelector('.product-video');
  wrapper.classList.add('hidden');
  document.querySelector('body').classList.remove('open-cart-drawer');
  video.pause();
}

document.querySelectorAll('.video-wrapper').forEach(button => {
  button.addEventListener('click', openVideo);
});

document.querySelectorAll('.video-close').forEach(button => {
  button.addEventListener('click', closeVideo);
});

if (window.location.search.indexOf('autoplayLiveShopping') !== -1) {
  const { hash } = window.location;
  const id = hash.split('#liveshopping-')[1];
  document.querySelector(`[data-show="${id}"]`).click();
}

const openLiveShopping = e => {
  const button = e.currentTarget;
  (function () {
    if (!window.initBambuserLiveShopping) {
      window.initBambuserLiveShopping = function (item) { window.initBambuserLiveShopping.queue.push(item) }; window.initBambuserLiveShopping.queue = [];
      const scriptNode = document.createElement('script');
      scriptNode.src = 'https://lcx-embed.bambuser.com/default/embed.js';
      document.body.appendChild(scriptNode);
    }

    window.initBambuserLiveShopping({
      showId: button.dataset.show,
      type: "overlay",
    });
  })();
}

document.querySelectorAll('.bambuser-initialize').forEach(button => {
  button.addEventListener('click', openLiveShopping);
});

if (window.location.search.indexOf('autoplayLiveShopping') !== -1) {
  const { hash } = window.location;
  const id = hash.split('#liveshopping-')[1];
  document.querySelector(`[data-show="${id}"]`).click();
}